/**
 * DevExtreme (esm/__internal/ui/scroll_view/scrollable.device.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import devices from "../../../core/devices";
import supportUtils from "../../core/utils/m_support";
export const deviceDependentOptions = function () {
  return [{
    device: () => !supportUtils.nativeScrolling,
    options: {
      useNative: false
    }
  }, {
    device: device => !devices.isSimulator() && "desktop" === devices.real().deviceType && "generic" === device.platform,
    options: {
      bounceEnabled: false,
      scrollByThumb: true,
      scrollByContent: supportUtils.touch,
      showScrollbar: "onHover"
    }
  }];
};